import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';

import { FullScreen, MenuItemType } from '../detail-action-button/detail-action-buttons.const';
import { MenuItem, MenuItemTypeConfigurations } from '../detail-action-button/detail-action-buttons.types';

@Component({
  selector: 'app-detail-overlay',
  templateUrl: './detail-overlay.component.html',
  styleUrl: './detail-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DetailOverlayComponent {
  @Input() visible: boolean;
  @Input() appendTo: HTMLElement;
  @Input() appendToFullScreen: HTMLElement;
  @Input() set item(menuItem: MenuItem) {
    const options = menuItem.typeOptions as MenuItemTypeConfigurations[MenuItemType.SIDEPANEL];
    const fullscreen = options.fullscreen === FullScreen.ALWAYS;
    this.currentItem.set(menuItem);
    this.alwaysFullscreen.set(fullscreen);
    this.fullscreen.set(fullscreen);
  }

  @Output() visibleChange = new EventEmitter<boolean>();

  currentItem = signal<MenuItem>(null);
  alwaysFullscreen = signal<boolean>(false);
  fullscreen = signal<boolean>(false);
  overlayStyling = computed(() => {
    return this.fullscreen() || this.alwaysFullscreen() ? 'w-full' : 'p-0 w-full sm:w-[24rem] md:w-[30rem]';
  });

  handleFullscreen() {
    this.visibleChange.emit(false);
    this.fullscreen.set(!this.fullscreen());
    setTimeout(() => {
      this.visibleChange.emit(true);
    }, 0);
  }
}
